import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/layout/BasicContainer.vue'),
    redirect: '/user_info',
    children: [
      {
        path: '/user_info',
        name: 'UserInfo',
        meta: {
          title: '账户管理',
          breadcrumb: ['账户管理', '用户信息'],
        },
        component: () => import('@/account/User.vue'),
      },
    ],
  },
  {
    path: '/cas/login',
    name: 'Login',
    component: () => import('@/login/loginIn.vue'),
  },
  {
    path: '/cas/logout',
    name: 'Logout',
    beforeEnter: (to, _, next) => {
      const { redirect_uri } = to.query
      window.localStorage.clear()
      if (redirect_uri) {
        window.location.replace(decodeURIComponent(redirect_uri))
      } else {
        next({ name: 'Login' })
      }
    },
  },
  {
    path: '/empty',
    component: () => import('@/empty/empty.vue'),
  },
  {
    path: '*',
    redirect: '/empty'
  }
]
const router = new VueRouter({
  mode: 'history',
  /* base: process.env.BASE_URL,
  scrollBehavior(savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }, */
  routes,
})

export default router
